<template>
<div id="layout_apendices" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="title" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="camposexcel" :name="title + '.xlsx'" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="camposLayout" :exportFields="encabezadoLayout" :name="'Layout ' + title + '.xlsx'" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>

                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Clave" type="text" v-model="model.clave" @blur="model.clave= leftPad(model.clave, 3, '0')" mask="###" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Descripción" type="text" v-model="model.descripcion" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                <v-combo-paises :option_combos="2" :param_pais="model.pais" :param_estado="model.estado" :on-select-pais="selectComboPais" :on-select-estado="selectComboEstado" />                                                
                                            </v-flex>
                                        </v-layout>

                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>

                                </template>
                                <template slot="filter__pais" >
                                    <v-combobox v-model="sel_pais" :items="paises_ciudades" :item-text="nombrePais" item-value="id" placeholder="Filtrar por Pais" class="form-control" solo clearable @change="applyFilter()" ></v-combobox>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-if="id_cliente == 0 || props.row.cliente == id_cliente" direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";

import ComboPaises from '@/components/ComboPaises/index.vue';
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import {
    Event
} from 'vue-tables-2';
import powerTitulo from "@/components/powerTitulo.vue";
export default {
    components: {
        "v-power-titulo": powerTitulo,
        "v-combo-paises": ComboPaises,
        "v-menu-lateral-apendice": menuLateral,
    },
    mounted() {},

    data: () => ({
        fab: false,
        paises_ciudades: [],
        sel_pais: "",
        name: "datagrid",
        importData: [],
        paises: [],
        estados: [],
        ciudades: [],

        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,
        datos: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        url_actions: "apendices/",
        url_list: "apendices/lista/",
        tabla: 24,
        title: "CLAVES DE CIUDADES",
        columns: ["clave", "descripcion", "pais", "estado", "actions"],
        options: {
            filterable: ["clave", "descripcion", "estado", ],
            sortable: ["clave", "descripcion", "pais", "estado", ],
            customFilters: [{
                name: 'porpais',

                callback: function (row, query) {
                    return row.pais == query.clave_m3 + ' - ' + query.nombre;
                }
            }],
            headings: {
                clave: "Clave",
                descripcion: "Descripción",
                pais: "País",
                estado: "Estado",
                actions: "Operaciones"
            },
        },
        camposexcel: {
            Clave: "clave",
            'Nombre Ciudad': "descripcion",
            País: "pais",
            Estado: "estado"
        },
        encabezadoLayout: {
            clave: "clave",
            descripcion: "descripcion",
            pais: "pais",
            estado: "estado"
        },
        camposLayout: [{
            clave: "[Clave Ciudad - 2 digitos]",
            descripcion: "[Nombre de la ciudad]",
            pais: "[Clave del país]",
            estado: "[Clave del estado]"
        }],
        model: {
            id: 0,
            clave: "",
            descripcion: "",
            pais: "",
            estado: "",
        },
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apendices",
                disabled: true,
                to: ""
            }
        ]

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.datos.items;
            }

        },
    },
    methods: {
        applyFilter() {

            Event.$emit('vue-tables.filter::porpais', this.sel_pais);

        },
        nombrePais: function (pais) {
            return (pais != undefined) ? pais.clave_m3 + " - " + pais.nombre : '';
        },
        leftPad: function (num, padlen, padchar) {
            var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
            var pad = new Array(1 + padlen).join(pad_char);
            if (num) return (pad + num).slice(-pad.length);
        },
        render(url) {
            this.$router.push(url);
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
        },

        guardar() {
            var datos = this.model;
            datos["tabla"] = this.tabla;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else if (this.model.estado == null || this.model.estado == "") {
                this.$swal({                    
                    type: "warning",
                    title: "Datos incompletos!",
                    text: "El estado es un campo requerido. Favor de seleccionar.",                                        
                });
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargar();
                        this.cargarPaisesCiudades();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            var datos = {
                tabla: this.tabla
            };
            axios
                .post(this.$hostname + this.url_list, datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos.items = res.data;
                        for (var k in this.datos.items) {
                            this.datos.items[k].pais = this.obtenerPais(this.datos.items[k].pais);
                            this.datos.items[k].estado = this.obtenerEstado(this.datos.items[k].estado);
                        }
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargar();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    if (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length > 3) {
                        errores++;
                        erroresText += "- La clave de ciudad \"" + results[k]["clave"] + "\" no debe ser mayor a 3 caracteres.<br>";
                    } else if (results[k]["clave"] == undefined || (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length == 0)) {
                        errores++;
                        erroresText += "- La clave de ciudad no debe estar vacía.<br>";
                    }

                    if (results[k]["pais"] != undefined) {
                        let verificaPaises = await thisObject.verificaComboPaises(results[k]["pais"], results[k]["estado"], results[k]["clave"]);
                        if (verificaPaises.toString().trim().length > 0) {
                            errores++;
                            if (erroresText.indexOf(verificaPaises) == -1)
                                erroresText += verificaPaises;
                        }
                    } else {
                        errores++;
                        erroresText += "- La clave de pais no debe estar vacía.<br>";
                    }

                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise      
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            /*for (var k in results){            
                  results[k]['user_updated'] = this.$local_storage.get('username'); 
                  //console.log("Key is " + k + ", value is" + results[k]);  
              }*/
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {
                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        results[k]["pais"] = id_pais;
                        var id_estado = results[k]["estado"] != undefined ? await this.verificaEstado(results[k]["estado"], id_pais, 'id') : '';
                        results[k]["estado"] = id_estado;
                        results[k]["clave"] = this.leftPad(results[k]["clave"], 3, '0');
                    }
                    let tabla = this.tabla;
                    this.importData = results;
                    axios
                        .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 2) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.cargarPaisesCiudades();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        selectComboPais(id) {
            this.model.pais = id;
        },
        selectComboEstado(id) {
            this.model.estado = id;
        },
        selectComboCiudad(id) {
            this.model.ciudad = id;
        },
        selectComboMunicipio(id) {
            this.model.municipio = id;
        },
        obtenerPais(id_pais) {
            let paises = this.paises.filter(function (e) {
                return e.id_pais == id_pais;
            });
            return paises.length > 0 ? (paises[0].clave_m3 + " - " + paises[0].nombre) : "N/A";
        },
        obtenerEstado(id_estado) {
            var estados = [];
            estados = this.estados.filter(function (e) {
                return e.id_estado == id_estado;
            });
            return estados.length > 0 ? (estados[0].clave + " - " + estados[0].nombre) : "N/A";
        },
        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargarEstados();
                });
        },
        cargarPaisesCiudades: function () {
            axios
                .get(this.$hostname + "catalogos/ciudades/get_ciudades_paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises_ciudades = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargarEstados();
                });
        },
        cargarEstados: function () {
            axios
                .get(this.$hostname + "estados/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.estados = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de estados",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de estados.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargar();
                });
        },
        verificaPaisesVacios: function (clave_pais, clave_estado, clave_ciudad) {
            var erroresText = '';
            if (clave_ciudad != undefined && clave_estado == undefined)
                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no debe tener el estado vacío.<br>";
            if (clave_estado != undefined && clave_pais == undefined)
                erroresText += "- La clave estado \"" + clave_estado + "\" no debe tener el país vacío.<br>";
            return erroresText;
        },
        verificaComboPaises: async function (clave_pais, clave_estado, clave_ciudad) {
            var erroresText = this.verificaPaisesVacios(clave_pais, clave_estado, clave_ciudad);
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            } else {
                let id_pais = await this.verificaPais(clave_pais, 'id');
                if (clave_estado != undefined) {
                    let verificaE = await this.verificaEstado(clave_estado, id_pais, '');
                    if (verificaE == 0) {
                        erroresText += "- La clave estado \"" + clave_estado + "\" no pertenece al país \"" + clave_pais + "\".<br>";
                    } else {
                        let id_estado = await this.verificaEstado(clave_estado, id_pais, 'id');
                        if (clave_ciudad != undefined) {
                            let verificaC = await this.verificaCiudad(clave_ciudad, id_pais, id_estado, '');
                            if (verificaC != 0) //Aqui verificamos si ya existe
                                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" ya existe para el estado \"" + clave_estado + "\".<br>";
                        }
                    }
                }

            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        verificaEstado: function (clave_estado, id_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_estado == undefined)
                    resolve(0);

                var search = thisObject.estados.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave_estado.toString().trim().toLowerCase() &&
                        e.pais == id_pais;
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_estado : '');
                else
                    resolve(search.length);
            });
        },
        verificaCiudad: function (clave_ciudad, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_ciudad == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            thisObject.ciudades = res.data;
                            var search = thisObject.ciudades.filter(function (e) {
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_ciudad.toString().trim())) || (e.clave.toString().trim() == clave_ciudad.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },
    }, //methods

    created: function () {
        this.URL = this.$hostname + this.url_actions;
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.id_cliente = this.$local_storage.get("id_cliente");
        if (this.id_cliente > 0 && this.tabla != 2) {
            //Los clientes no pueden modificar los apendices, excepto el de 2-Unidades de Medida y (por definir PILOS)
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargarPaises();
        this.cargarPaisesCiudades();

    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>